import {
  registerComponent,
  getComponentConfig,
  loading,
  asyncRequest,
} from "helpers";

registerComponent(
  "swatch-link",
  class SwatchLink extends HTMLElement {
    constructor() {
      super();

      this.config = getComponentConfig(this);
      this.productSummary = this.closest(".product-summary");
      this.productMedia = this.productSummary.querySelector(
        ".product-summary__media"
      );
      this.link = this.querySelector("a");

      this.link.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(event) {
      event.preventDefault();

      loading.add(this.productMedia);

      this.getProductSummary();
    }

    async getProductSummary() {
      const response = await asyncRequest(`${this.config.url}&view=summary`);

      if (response) {
        this.handleSuccessfulUpdate(response);
      } else {
        window.location.href = this.config.url;
      }
    }

    handleSuccessfulUpdate(html) {
      this.productSummary.outerHTML = html;
    }
  }
);
